<template>
  <div id="count-promocode-delete" v-if="hasCount()">
    <div class="alert alert-dismissible" :class="'alert-' + getLevelPayload()" role="alert" @click="onClick()">
      <div class="d-flex">
        {{ getTitlePayload() }}: {{ count }}
      </div>
    </div>
  </div>
</template>

<script>
import {defineComponent, onMounted, ref} from "vue"
import { useRouter } from 'vue-router'
import Api from "./services/Api"

export default defineComponent({
  name: "CountPromocodeDelete",
  components: {},
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const router = useRouter()
    const levels = {
      danger: 'danger',
      muted: 'muted',
    }

    let payload = geyPayload()
    let count = ref(0)

    onMounted(() => {
      let query = {}

      getCount(query).then((resp) => {
        count.value = resp?.coupon_delst ?? 0
      })
    })

    function onClick() {
      router.push({name: "PromocodesListCouponDelete"})
    }

    async function getCount(query) {
      return await Api.statistic(query)
    }

    function geyPayload() {
      let title = "Промокодов на удаление"
      let level

      if (props?.payload?.level === levels.muted) {
        level = levels.muted
      } else {
        level = levels.danger
      }

      if (
          props.payload.title !== "" &&
          props.payload.title !== undefined &&
          props.payload.title !== null
      ) {
        title = props.payload.title
      }

      return {
        title,
        level,
      }
    }

    function getTitlePayload() {
      return payload.title
    }

    function getLevelPayload() {
      return payload.level
    }

    function hasCount() {
      return count.value > 0
    }

    return {
      onClick,
      count,
      hasCount,
      getTitlePayload,
      getLevelPayload,
    }
  },
})
</script>

<style scoped>
  #count-promocode-delete .alert {
    font-size: 16px
  }
  #count-promocode-delete .alert:hover {
    cursor: pointer;
  }
</style>
